import isEmpty from 'lodash/isEmpty';

import { logger } from '../../util/logger';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';
import { ChatbotErrorResponse } from './types';

const {
  clientTopology: { mediaTokenUrl },
} = renderModel.get();

type MediaTokenResponse = {
  mediaAuthToken: string;
};

let mediaToken: string | null;

export const getMediaAuthToken = async (): Promise<string | null> => {
  if (mediaToken) {
    return mediaToken;
  }
  fedopsLogger.interactionStarted('fetching-media-token');
  try {
    const { data } = await httpClient
      .getInstance()
      .get<MediaTokenResponse & ChatbotErrorResponse>(mediaTokenUrl);
    if (isEmpty(data)) {
      return null;
    }
    if (data.error) {
      throw new Error(data.error.message);
    }

    fedopsLogger.interactionEnded('fetching-media-token');
    mediaToken = data.mediaAuthToken;
    return data.mediaAuthToken;
  } catch (error) {
    const message = 'Failed to get media token';
    logger.error({ error, message });
    console.error(error);
    return null;
  }
};
